<div class="ion-page">
  <ion-header>
    <ion-toolbar color="secondary">
      <ion-title style="text-align: center;">
        {{report ? report.Title : ('New Report' | translate)}}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button fill="clear" (click)="onBack()">
          <ion-icon name="close" style="color: var(--ion-color-secondary-contrast);"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <div>
      <form [formGroup]="reportForm">

        <!-- Basic Information Section -->
        <ion-card>
          <ion-card-header>
            <ion-card-title style="display: flex; align-items: center; gap: 8px;color:var(--ion-color-secondary-contrast);">
              <ion-icon name="information-circle-outline" class="section-icon"></ion-icon>
              <span>{{ 'Basic Information' | translate }}</span>
            </ion-card-title>
          </ion-card-header>
          <ion-card-content>

            <!-- Report Name -->
            <ion-item lines="none" [class.item-has-error]="reportForm.get('Title')?.hasError('maxlength') || (reportForm.get('Title')?.hasError('required') && reportFormSubmitted)">
              <ion-label position="stacked">{{ 'Report Name' | translate }}</ion-label>
              <ion-input
                type="text"
                formControlName="Title"
                placeholder="Enter report name"
                [class.ion-invalid]="reportForm.get('Title')?.hasError('maxlength') || (reportForm.get('Title')?.hasError('required') && reportFormSubmitted)"
                [class.ion-touched]="reportForm.get('Title')?.hasError('maxlength') || reportFormSubmitted"
                [errorText]="reportForm.get('Title')?.hasError('maxlength') ? ('Max 55 characters allowed' | translate) : ('This field is required' | translate)">
              </ion-input>
            </ion-item>

            <!-- Report ID (Read-only) -->
            <ion-item lines="inset" disabled="true" style="filter: contrast(1) brightness(1);">
              <ion-label position="stacked">{{ 'Report ID' | translate }}</ion-label>
              <ion-input
                type="text"
                formControlName="ReportGUID"
                readonly="true">
              </ion-input>
            </ion-item>

            <!-- Report Type (Read-only) -->
            <ion-item lines="inset" formGroupName="ReportType" disabled="true" style="filter: contrast(1) brightness(1);">
              <ion-label position="stacked">{{ 'Report Type' | translate }}</ion-label>
              <ion-input
                type="text"
                formControlName="ReportType"
                readonly="true">
              </ion-input>
            </ion-item>

            <!-- Description -->
            <ion-item lines="inset">
              <ion-label position="stacked">{{ 'Description' | translate }}</ion-label>
              <ion-textarea
                [autoGrow]="true"
                formControlName="Description"
                placeholder="Enter report description"
                rows="3">
              </ion-textarea>
            </ion-item>

          </ion-card-content>
        </ion-card>

        <!-- Report Image Section -->
        <ion-card>
          <ion-card-header>
            <ion-card-title style="display: flex; align-items: center; gap: 8px;color:var(--ion-color-secondary-contrast);">
              <ion-icon name="image-outline" class="section-icon"></ion-icon>
              <span>{{ 'Report Image' | translate }}</span>
            </ion-card-title>
          </ion-card-header>
          <ion-card-content>

            <div>
              <div>
                @if (responseNewLogo) {
                  <!-- Has newly uploaded logo -->
                  @if (isPublicLogoUrl(responseNewLogo?.ImageURI ?? '')) {
                    <ion-img class="logo"
                      [src]="$safeNavigationMigration(responseNewLogo?.ImageURI)" alt="Report preview image">
                    </ion-img>
                  }
                  @if (!isPublicLogoUrl(responseNewLogo?.ImageURI ?? '')) {
                    @if ((responseNewLogo?.ImageURI ?? '') | secureBlob | async; as imgSrc) {
                      <img class="logo" [src]="imgSrc" alt="Report preview image" />
                    }
                  }
                } @else {
                  @if (report?.ImageURI; as imageUri) {
                    <!-- Has existing report ImageURI -->
                    @if (isPublicLogoUrl(imageUri)) {
                      <ion-img class="logo"
                        [src]="imageUri" alt="Report preview image">
                      </ion-img>
                    }
                    @if (!isPublicLogoUrl(imageUri)) {
                      @if (imageUri | secureBlob | async; as imgSrc) {
                        <img class="logo" [src]="imgSrc" alt="Report preview image" />
                      }
                    }
                  } @else {
                    @if (isPublicLogoUrl(groupImg ?? '')) {
                      <ion-img class="logo"
                        [src]="groupImg"
                        alt="Report preview image">
                      </ion-img>
                    }
                    @if (!isPublicLogoUrl(groupImg ?? '')) {
                      @if ((groupImg ?? '') | secureBlob | async; as imgSrc) {
                        <img class="logo" [src]="imgSrc" alt="Report preview image" />
                      }
                    }
                  }
                  <!-- Fallback: group image -->
                }
              </div>
              <br>
                <div>
                  <ion-button style="--background:var(--ion-color-adminDetailsViewActive);max-width: 60%; margin-left: 20%;" expand="block" class="btn">
                    <input type="file" name="file" id="file" class="inputfile" (change)="uploadLogo($event)"/>
                    <ion-icon name="cloud-upload-outline" style="color:var(--ion-color-adminDetailsViewActive-contrast);"></ion-icon>&nbsp;
                    <label for="file" style="color:var(--ion-color-adminDetailsViewActive-contrast);">{{ 'Upload Image' | translate }}</label>
                  </ion-button>
                </div>
              </div>

            </ion-card-content>
          </ion-card>
          <!-- Security & RLS Section -->
          @if (report?.ReportTypeID == 1) {
            <ion-card class="section-card">
              <ion-card-header>
                <ion-card-title style="display: flex; align-items: center; gap: 8px;color:var(--ion-color-secondary-contrast);">
                  <ion-icon name="shield-outline" class="section-icon"></ion-icon>
                  <span>{{ 'Security Settings' | translate }}</span>
                </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <!-- RLS Toggle -->
                <ion-item lines="inset">
                  <ion-label>
                    <h3>{{ 'Row Level Security (RLS)' | translate }}</h3>
                    <p>{{ 'Enable row-level security for this report' | translate }}</p>
                  </ion-label>
                  <ion-checkbox formControlName="RLS" (ionChange)="enabledRLS($event)" slot="end" style="margin-right: 1em"></ion-checkbox>
                </ion-item>
                <!-- RLS Configuration -->
                @if (hasRLS) {
                  <div class="rls-config">
                    <div formGroupName="RLSRole">
                      <!-- RLS Type Selection -->
                      <ion-item lines="inset" formGroupName="eIdType">
                        <ion-label position="stacked">{{ 'RLS Type' | translate }}</ion-label>
                        <ion-select
                          interface="popover"
                          formControlName="eIdTypeID"
                          placeholder="Select RLS Type"
                          (ionChange)="RLSTypeChanged($event)">
                          <ion-select-option [value]="1">{{ 'Email' | translate }}</ion-select-option>
                          <ion-select-option [value]="2">{{ configuration?.BusinessUnitName ?? ('Group' | translate) }} {{ 'Name' | translate }}</ion-select-option>
                          <ion-select-option [value]="3">{{ 'User Email Domain Name' | translate }}</ion-select-option>
                          <ion-select-option [value]="4">{{ 'SSAS EffectiveIdentity username/input' | translate }}</ion-select-option>
                        </ion-select>
                        <ion-button fill="clear" slot="end" id="RLSTypePopover">
                          <ion-icon name="help-circle-outline" color="medium" class="questionPopoverIcon"></ion-icon>
                        </ion-button>
                      </ion-item>
                      <!-- RLS Role/Username Input -->
                      @if (hasRLSType) {
                        <ion-item lines="inset">
                          <ion-label position="stacked">
                            {{ usesSSASEIdUsername ? ('EffectiveIdentity Username' | translate) : ('RLS Role Name' | translate) }}
                          </ion-label>
                          <ion-input
                            style="margin-left: -8px;"
                            type="text"
                            formControlName="eIdInput"
                            [placeholder]="usesSSASEIdUsername ? ('EffectiveIdentity Username' | translate) : ('RLS Role Name' | translate)">
                          </ion-input>
                          <ion-button fill="clear" slot="end" id="RLSNamePopover">
                            <ion-icon name="help-circle-outline" color="medium" class="questionPopoverIcon"></ion-icon>
                          </ion-button>
                        </ion-item>
                      }
                    </div>
                  </div>
                }
              </ion-card-content>
            </ion-card>
          }

          <!-- Display Options Section -->
          <ion-card class="section-card">
            <ion-card-header>
              <ion-card-title style="display: flex; align-items: center; gap: 8px; color:var(--ion-color-secondary-contrast);">
                <ion-icon name="options-outline" class="section-icon"></ion-icon>
                <span>{{ 'Display Options' | translate }}</span>
              </ion-card-title>
            </ion-card-header>
            <ion-card-content>

              <ion-item lines="inset">
                <ion-label>
                  <h3>{{ 'Filter menu' | translate }}</h3>
                  <p>{{ 'Enable or disable the filter menu for this report' | translate }}</p>
                </ion-label>
                <ion-checkbox formControlName="FilterMenu" slot="end" style="margin-right: 1em"></ion-checkbox>
              </ion-item>

              <ion-item lines="inset">
                <ion-label>
                  <h3>{{ 'Page bar' | translate }}</h3>
                  <p>{{ 'Enable or disable the page bar for this report' | translate }}</p>
                </ion-label>
                <ion-checkbox formControlName="PageBar" slot="end" style="margin-right: 1em"></ion-checkbox>
              </ion-item>

              <ion-item lines="inset">
                <ion-label>
                  <h3>{{ 'Bookmark Pane' | translate }}</h3>
                  <p>{{ 'Enable or disable the bookmark pane for this report' | translate }}</p>
                </ion-label>
                <ion-checkbox formControlName="BookmarkPane" slot="end" style="margin-right: 1em"></ion-checkbox>
              </ion-item>

              <ion-item lines="inset">
                <ion-label>
                  <h3>{{ 'Mobile View' | translate }}</h3>
                  <p>{{ 'Optimize report display for mobile devices' | translate }}</p>
                </ion-label>
                <ion-checkbox formControlName="MobileFriendly" slot="end" style="margin-right: 1em"></ion-checkbox>
              </ion-item>

              <ion-item lines="none">
                <ion-label>
                  <h3>{{ 'Allow Export' | translate }}</h3>
                  <p>{{ 'Allow users to export this report as PDF or PPTX' | translate }}</p>
                </ion-label>
                <ion-checkbox formControlName="AllowExport" slot="end" style="margin-right: 1em"></ion-checkbox>
              </ion-item>

              <ion-item lines="inset">
                <ion-label>
                  <h3>{{ 'Published' | translate }}</h3>
                  <p>{{ 'Make this report available to users' | translate }}</p>
                </ion-label>
                <ion-checkbox formControlName="Published" slot="end" style="margin-right: 1em"></ion-checkbox>
              </ion-item>

              <ion-item lines="none">
                <ion-label>
                  <h3>{{ 'Pinned' | translate }}</h3>
                  <p>{{ 'Pin this report to the top of the lists' | translate }}</p>
                </ion-label>
                <ion-checkbox formControlName="Pinned" slot="end" style="margin-right: 1em"></ion-checkbox>
              </ion-item>

            </ion-card-content>
          </ion-card>

        </form>

        <!-- Action Buttons -->
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-button color="tertiary" expand="block" (click)="testEmbedding()">{{ 'Test Embedding' | translate }}</ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button color="tertiary" expand="block" (click)="onBack()">
                {{ 'Cancel' | translate }}
              </ion-button>
            </ion-col>
            <ion-col>
              <ion-button color="medium" expand="block" (click)="saveReport()" type="submit">
                {{report ? ('Save' | translate) : ('Create' | translate)}}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>

      </div>

      <!-- Help Popovers -->
      <ng-container>

        <ion-popover trigger="RLSNamePopover" [cssClass]="'custom-popover-css'">
          <ng-template>
            @if(usesSSASEIdUsername) {
              <ion-text style="padding-top: 14px; padding-left: 10px; padding-right:5px; background-color: var(--ion-color-secondary);">
                <b>{{ 'SSAS EffectiveIdentity username/input:' | translate }}</b>
              </ion-text>
              <ion-text style="padding-top: 8px; padding-bottom: 14px; padding-left: 10px; padding-right:5px; background-color: var(--ion-color-secondary);">
                {{ 'Uses the given value as the Username instead of the Role name when embedding the report.' | translate }}
                {{ 'This value needs to be a Username used when setting up the Gateway for the SSAS, and the service-principal used to get the report needs to be set as Admin on the Gateway.' | translate }}
              </ion-text>
            }
            @if(!usesSSASEIdUsername) {
              <ion-text style="padding-top: 14px; padding-left: 10px; padding-right:5px; background-color: var(--ion-color-secondary);">
                <b>{{ 'RLS Role Name:' | translate }}</b>
              </ion-text>
              <ion-text style="padding-top: 8px; padding-bottom: 14px; padding-left: 10px; padding-right:5px; background-color: var(--ion-color-secondary);">
                {{ 'The name of the Role configured in the report that the Username value (choosen above) will be used with when embedding the report.' | translate }}
              </ion-text>
            }
          </ng-template>
        </ion-popover>


        <ion-popover trigger="RLSTypePopover" [cssClass]="'custom-popover-css'">
          <ng-template>
            <ion-text style="padding-top: 14px; padding-bottom: 8px; padding-left: 5px; padding-right:5px; text-align: center; background-color: var(--ion-color-secondary);">
              {{ 'RLS Type sets what value and in what way the Username and Role name inputs are used when embedding the report.' | translate }}
            </ion-text>
            <ion-text style="padding-top: 8px; padding-bottom: 8px; padding-left: 5px; padding-right:5px; text-align: center; background-color: var(--ion-color-secondary);">
              <b>{{ 'Email:' | translate }}</b> {{ 'Uses the Entire Email as the Username/RLS input.' | translate }}
            </ion-text>
            <ion-text style="padding-top: 8px; padding-bottom: 8px; padding-left: 5px; padding-right:5px; text-align: center; background-color: var(--ion-color-secondary);">
              <b>{{configuration?.BusinessUnitName ?? "Group"}} {{ 'Name:' | translate }}</b> {{ 'Uses the Name of the group that the user had chosen when they open the report as Username.' | translate }}
            </ion-text>
            <ion-text style="padding-top: 8px; padding-bottom: 8px; padding-left: 5px; padding-right:5px; text-align: center; background-color: var(--ion-color-secondary);">
              <b>{{ 'User Email Domain Name:' | translate }}</b> {{ 'Uses only the Domain of the users Email as the Username.' | translate }}
            </ion-text>
            <ion-text style="padding-top: 8px; padding-bottom: 14px; padding-left: 5px; padding-right:5px; text-align: center; background-color: var(--ion-color-secondary);">
              <b>{{ 'SSAS EffectiveIdentity username/input:' | translate }}</b> {{ 'Uses the given value below as the Username and does not use any RLS Role.' | translate }}
            </ion-text>
          </ng-template>
        </ion-popover>
      </ng-container>

    </ion-content>
  </div>
